import { JobTypeEnum, JobTypeSchema } from '@eigtech/restoration-types'

const jobTypeLabelRecord: Record<JobTypeEnum, string> = {
  daily: 'Build Back',
  otr: 'OTR',
  emergencyServices: 'Emergency Services',
}

export const getJobTypeLabel = (type: JobTypeEnum): string => jobTypeLabelRecord[type]

export const jobTypeLabels = Object.fromEntries(
  JobTypeSchema.options.map((key) => [key, getJobTypeLabel(key)])
) as Record<JobTypeEnum, string>
